import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import messages from '@/i18n/index'
import router from '@/router/index'
import "@/assets/font/font.scss";
import VueLazyload from 'vue-lazyload'
import store from '@/store/index'

Vue.use(VueLazyload)
Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: "en",
  messages,
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 3
})

let link = {}
const param = window.location.href.split('?')[1]
if (param) {
  const arr = param.split('&')
  arr.map(i => {
    link[i.split('=')[0]] = i.split('=')[1]
  })
}

if (link.lang == 'id') {
  i18n.locale = 'id'
} else {
  i18n.locale = 'en'
}

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
